import { render, staticRenderFns } from "./Header-1.vue?vue&type=template&id=83161514&scoped=true&"
import script from "./Header-1.vue?vue&type=script&lang=js&"
export * from "./Header-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83161514",
  null
  
)

export default component.exports